import {
  checkChortkeAvailability,
  getAssortmentRegion,
  getAssortmentVendor,
  getProductsPriceTracking
} from './thunk';

export const builderCheckChortkeAvailability = (builder: any) => {
  builder
    .addCase(checkChortkeAvailability.pending, (state: any) => {
      state.gettingCheckChortkeAvailability = true;
      state.checkChortkeAvailabilitySuccess = false;
      state.checkChortkeAvailabilityData = null;
    })
    .addCase(checkChortkeAvailability.fulfilled, (state: any, action: any) => {
      state.gettingCheckChortkeAvailability = false;
      state.checkChortkeAvailabilitySuccess = true;
      state.checkChortkeAvailabilityData = action.payload;
    })
    .addCase(checkChortkeAvailability.rejected, (state: any) => {
      state.gettingCheckChortkeAvailability = false;
      state.checkChortkeAvailabilitySuccess = false;
      state.checkChortkeAvailabilityData = null;
    });
};

export const builderGetAssortmentRegion = (builder: any) => {
  builder
    .addCase(getAssortmentRegion.pending, (state: any) => {
      state.gettingAssortmentRegion = true;
      state.assortmentRegionSuccess = false;
      state.assortmentRegionItems = [];
    })
    .addCase(getAssortmentRegion.fulfilled, (state: any, action: any) => {
      state.gettingAssortmentRegion = false;
      state.assortmentRegionSuccess = true;
      state.assortmentRegionItems = action.payload?.products;
    })
    .addCase(getAssortmentRegion.rejected, (state: any) => {
      state.gettingAssortmentRegion = false;
      state.assortmentRegionSuccess = false;
      state.assortmentRegionItems = [];
    });
};

export const builderGetAssortmentVendor = (builder: any) => {
  builder
    .addCase(getAssortmentVendor.pending, (state: any) => {
      state.gettingAssortmentVendor = true;
      state.assortmentVendorSuccess = false;
      state.assortmentVendorItems = [];
    })
    .addCase(getAssortmentVendor.fulfilled, (state: any, action: any) => {
      state.gettingAssortmentVendor = false;
      state.assortmentVendorSuccess = true;
      state.assortmentVendorItems = action.payload?.products;
    })
    .addCase(getAssortmentVendor.rejected, (state: any) => {
      state.gettingAssortmentVendor = false;
      state.assortmentVendorSuccess = false;
      state.assortmentVendorItems = [];
    });
};

export const builderGetProductsPriceTracking = (builder: any) => {
  builder
    .addCase(getProductsPriceTracking.pending, (state: any) => {
      state.loading += 1;
    })
    .addCase(getProductsPriceTracking.fulfilled, (state: any, action: any) => {
      state.productsPriceTracking = action.payload;
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    })
    .addCase(getProductsPriceTracking.rejected, (state: any) => {
      state.loading = state.loading !== 0 ? state.loading - 1 : state.loading;
    });
};
